import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { AppRoleService } from '@nk/access-block';
import { AuthInfo } from '@nk/auth-lib';
import { AppIdentityCompositeEntity, AppRoleDims } from '@nk/data-entities-lib';
import { Dict } from '@nk/utils-lib';
import { Observable } from 'rxjs';

@Component({
  selector: 'nk-login-authenticated',
  templateUrl: 'login-authenticated.component.html',
  standalone: false,
})
export class LoginAuthenticatedComponent implements OnInit, OnChanges {
  @Input() public authInfo: AuthInfo;
  @Input() public identity: AppIdentityCompositeEntity;
  @Input() public identityList: AppIdentityCompositeEntity[];
  @Output() public logoutClick = new EventEmitter();
  @Output() public dashboardClick = new EventEmitter();
  @Output() public customerClick = new EventEmitter();
  @Output() public logoutAndRedirectToLogin = new EventEmitter();
  public appRoleDims$: Observable<Dict<AppRoleDims>>;
  public adminIdentityList: AppIdentityCompositeEntity[];

  constructor(private _appRoleService: AppRoleService) {}

  public ngOnInit(): void {
    this.appRoleDims$ = this._appRoleService.allActiveAppRoleDimsCache.get();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.identityList && this.identityList) {
      this.identityList = this.identityList.sort((a, b) => {
        return a.app_customer.name.localeCompare(b.app_customer.name);
      });
      this.adminIdentityList = this.identityList.filter((a, b) => {
        return (
          a.app_customer.slug === 'admin' ||
          a.app_customer.slug === 'test' ||
          a.app_customer.slug === 'demo' ||
          a.app_customer.slug === ''
        );
      });
    }
  }
}
